// Lightweight i18n. EN / PL / ES
const dict = {
  en: {
    app: 'Physiogenic',
    tagline: 'A modern physiotherapy platform for Physiogenic — HIPAA & GDPR ready, Polish-first.',
    cta_get_started: 'Get started',
    cta_learn_more: 'Learn more',
    nav_features: 'Features',
    nav_compliance: 'Compliance',
    nav_about: 'About',
    nav_about_us: 'About us',
    nav_platform: 'Allied Healthcare Platform',
    nav_login: 'Sign in',
    nav_register: 'Create account',
    nav_logout: 'Sign out',
    auth_email: 'Email',
    auth_password: 'Password',
    auth_name: 'Full name',
    auth_invite: 'Invite code (optional)',
    auth_login: 'Sign in',
    auth_register: 'Create account',
    auth_or: 'or',
    auth_google: 'Continue with Google',
    auth_google_signup: 'Sign up with Google',
    auth_have_account: 'Already have an account?',
    auth_no_account: "Don't have an account?",
    dashboard: 'Dashboard',
    patients: 'Patients',
    appointments: 'Appointments',
    documents: 'Medical Documents',
    invoices: 'Invoices',
    finances: 'Finances',
    exercises: 'Exercise Library',
    marketing: 'Marketing',
    invite: 'Invite Patients',
    taxes: 'Tax Reports',
    profile: 'Profile',
    upcoming: 'Upcoming sessions',
    no_data: 'No records yet',
    new: 'New',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    save: 'Save',
    download: 'Download',
    upload: 'Upload',
    pay_now: 'Pay now',
    paid: 'Paid',
    unpaid: 'Unpaid',
    overdue: 'Overdue',
    completed: 'Completed',
    cancelled: 'Cancelled',
    scheduled: 'Scheduled',
    consent_gdpr: 'I consent to GDPR data processing',
    consent_hipaa: 'I consent to HIPAA medical record handling',
    welcome_back: 'Welcome back',
    quick_actions: 'Quick actions',
    /* iter 83 — patient + GP-facing tiles ─────────────────────────────── */
    your_recovery: 'YOUR RECOVERY',
    pain_label: 'NPRS / VAS pain',
    share: 'Share',
    start: 'Start',
    now: 'Now',
    better: 'better',
    recovered: 'Recovered',
    in_progress: 'In progress',
    checkins: 'check-ins',
    recovery_help: '"Recovered" means a ≥ {n}-point drop on your pain scale — the same threshold your referring GP sees.',
    recovery_empty: 'We need at least two pain check-ins before we can show your trend. Log your current pain after your next session and your tile will appear.',
    /* GP-facing pages */
    gp_referral_flywheel: 'REFERRAL FLYWHEEL',
    gp_earnings_title: 'GP earnings & impact',
    gp_earnings_lede: 'Every referring GP that\'s been e-mailed a 30-day outcomes report from your clinic shows up below. Sort the leaderboard by sessions delivered, recovery rate or revenue.',
    export_csv: 'Export CSV',
    fee_schedule: 'Fee schedule',
    active_gps: 'Active GPs',
    referrals_30d: 'Referrals (30 d)',
    sessions_delivered: 'Sessions delivered',
    clinic_revenue: 'Clinic revenue',
    top_referrer: 'Top referrer this period',
    gp_leaderboard: 'GP leaderboard',
    fee_owed: 'Fee owed',
    no_gp_yet: 'No GP referrers yet — once you e-mail a 30-day outcomes report (or capture a GP referrer manually on a patient chart), they\'ll appear here.',
    referrals: 'Referrals',
    sessions: 'Sessions',
    recovery_pct: 'Recovery %',
    reports_sent: 'Reports sent',
    revenue: 'Revenue',
    open_inbox: 'Open inbox',
    /* GP inbound page */
    referral_inbox: 'REFERRAL INBOX',
    inbound_gp_referrals: 'Inbound GP referrals',
    inbound_lede: 'Every submission from a public referral link lands here. Move each one through Acknowledged → Scheduled (or Decline) — each transition sends an auto-reply email to the referring GP.',
    filter: 'Filter',
    all_statuses: 'All statuses',
    status_new: 'New',
    status_acknowledged: 'Acknowledged',
    status_scheduled: 'Scheduled',
    status_declined: 'Declined',
    clear_gp_filter: 'Clear GP filter',
    showing_x_of_y: 'Showing {x} / {y}',
    no_referrals_match: 'No referrals match this filter.',
    acknowledge: 'Acknowledge',
    schedule: 'Schedule',
    decline: 'Decline',
    audit: 'Audit',
    referred_by: 'Referred by',
    urgency: 'Urgency',
    discipline: 'Discipline',
    patient: 'Patient',
    /* Public GP refer page */
    refer_patient_to: 'Refer your patient to',
    referrer: 'Referrer',
    referral_received: 'Referral received — thank you',
    referral_received_body: 'We\'ll contact {name} within one working day to schedule their first appointment. The clinic admin team has been notified.',
    patient_full_name: 'Patient full name',
    patient_email: 'Patient email',
    patient_phone: 'Patient phone',
    presenting_complaint: 'Presenting complaint',
    urgency_urgent: 'Urgent (this week)',
    urgency_standard: 'Standard (1–2 weeks)',
    urgency_flexible: 'Flexible',
    note_optional: 'Note (optional)',
    send_referral: 'Send referral',
    referral_link_invalid: 'This referral link is no longer valid.',
    /* GP notification preferences (iter 83) */
    gp_prefs_title: 'Notification preferences',
    gp_prefs_lede: 'Choose which messages you\'d like to receive from this clinic.',
    pref_outcomes_report: '30-day outcomes report',
    pref_outcomes_help: 'A branded PDF summary mailed once per referred patient.',
    pref_status_replies: 'Status updates',
    pref_status_help: 'Acknowledged / scheduled / declined auto-replies.',
    pref_thank_you: 'Thank-you nudge',
    pref_thank_you_help: 'Quarterly note when your referred patients recover.',
    save_preferences: 'Save preferences',
    preferences_saved: 'Preferences saved — thank you.',
    /* PostureCapture PDF (iter 83) */
    export_to_pdf: 'Export PDF',
    no_snapshots_to_export: 'Pick at least one snapshot to export.',
    posture_pdf_caption: 'Posture snapshots',
    /* Iter 90-93 — Account & Privacy strings ─────────────────────────── */
    account_privacy: 'Account & Privacy',
    account_privacy_lede: 'Two-factor auth, your data, and account deletion — all in one place.',
    your_data: 'Your data',
    your_data_lede: 'Download a JSON file containing every record we hold about you (GDPR Article 20).',
    download_my_data: 'Download my data (.json)',
    email_me_the_export: 'Email it to me instead',
    monthly_transparency_email: 'Monthly transparency email',
    monthly_transparency_lede: 'Once a month we email you a summary of what we hold about you (GDPR Article 12). Last sent: {last}.',
    email_me_monthly_summary: 'Email me a monthly summary of my data',
    privacy_preferences: 'Privacy preferences',
    privacy_preferences_lede: 'Toggle individual data uses on or off. Withdraw any consent any time (GDPR Article 7).',
    consent_granted: 'Granted',
    consent_not_granted: 'Not granted',
    danger_zone: 'Danger zone',
    delete_account_lede: "Delete your account permanently. You'll have a 30-day grace period to change your mind by signing back in.",
    delete_my_account: 'Delete my account',
    deletion_pending_lede: 'Your account is scheduled for deletion in {days} day(s) ({date}). All your data will be permanently erased after that date.',
    cancel_deletion: 'Cancel deletion — keep my account',
  },
  pl: {
    app: 'Physiogenic',
    tagline: 'Nowoczesna platforma fizjoterapii dla Physiogenic — zgodna z RODO i HIPAA.',
    cta_get_started: 'Rozpocznij',
    cta_learn_more: 'Dowiedz się więcej',
    nav_features: 'Funkcje',
    nav_compliance: 'Zgodność',
    nav_about: 'O nas',
    nav_about_us: 'O nas',
    nav_platform: 'Platforma Ochrony Zdrowia',
    nav_login: 'Zaloguj się',
    nav_register: 'Zarejestruj się',
    nav_logout: 'Wyloguj',
    auth_email: 'E-mail',
    auth_password: 'Hasło',
    auth_name: 'Imię i nazwisko',
    auth_invite: 'Kod zaproszenia (opcjonalnie)',
    auth_login: 'Zaloguj',
    auth_register: 'Załóż konto',
    auth_or: 'lub',
    auth_google: 'Kontynuuj z Google',
    auth_google_signup: 'Zarejestruj się z Google',
    auth_have_account: 'Masz już konto?',
    auth_no_account: 'Nie masz konta?',
    dashboard: 'Panel',
    patients: 'Pacjenci',
    appointments: 'Wizyty',
    documents: 'Dokumenty medyczne',
    invoices: 'Faktury',
    finances: 'Finanse',
    exercises: 'Baza ćwiczeń',
    marketing: 'Marketing',
    invite: 'Zaproś pacjenta',
    taxes: 'Raporty podatkowe',
    profile: 'Profil',
    upcoming: 'Nadchodzące wizyty',
    no_data: 'Brak danych',
    new: 'Nowy',
    edit: 'Edytuj',
    delete: 'Usuń',
    cancel: 'Anuluj',
    save: 'Zapisz',
    download: 'Pobierz',
    upload: 'Wyślij',
    pay_now: 'Zapłać',
    paid: 'Opłacone',
    unpaid: 'Nieopłacone',
    overdue: 'Zaległe',
    completed: 'Zakończone',
    cancelled: 'Anulowane',
    scheduled: 'Zaplanowane',
    consent_gdpr: 'Wyrażam zgodę na przetwarzanie danych (RODO)',
    consent_hipaa: 'Wyrażam zgodę na obsługę danych medycznych (HIPAA)',
    welcome_back: 'Witaj ponownie',
    quick_actions: 'Szybkie akcje',
    /* iter 83 — patient + GP-facing tiles (PL) */
    your_recovery: 'TWÓJ POSTĘP',
    pain_label: 'Ból NPRS / VAS',
    share: 'Udostępnij',
    start: 'Start',
    now: 'Teraz',
    better: 'lepiej',
    recovered: 'Wyzdrowiał(a)',
    in_progress: 'W trakcie',
    checkins: 'pomiarów',
    recovery_help: '"Wyzdrowiał(a)" oznacza spadek ≥ {n} punktów na skali bólu — ten sam próg, który widzi Twój lekarz kierujący.',
    recovery_empty: 'Potrzebujemy co najmniej dwóch pomiarów bólu, aby pokazać Twój trend. Zapisz aktualny poziom bólu po następnej wizycie i Twój kafelek się pojawi.',
    gp_referral_flywheel: 'KOŁO ZAMACHOWE SKIEROWAŃ',
    gp_earnings_title: 'Wynagrodzenia i wpływ lekarzy kierujących',
    gp_earnings_lede: 'Każdy lekarz kierujący, do którego wysłano 30-dniowy raport wyników, pojawia się poniżej. Sortuj ranking według sesji, tempa zdrowienia lub przychodu.',
    export_csv: 'Eksport CSV',
    fee_schedule: 'Harmonogram opłat',
    active_gps: 'Aktywni lekarze',
    referrals_30d: 'Skierowania (30 dni)',
    sessions_delivered: 'Zrealizowane sesje',
    clinic_revenue: 'Przychód kliniki',
    top_referrer: 'Najlepszy lekarz w okresie',
    gp_leaderboard: 'Ranking lekarzy',
    fee_owed: 'Należna opłata',
    no_gp_yet: 'Brak lekarzy kierujących — po wysłaniu pierwszego 30-dniowego raportu (lub ręcznym zapisaniu lekarza na karcie pacjenta) pojawią się tutaj.',
    referrals: 'Skierowania',
    sessions: 'Sesje',
    recovery_pct: 'Zdrowienie %',
    reports_sent: 'Wysłane raporty',
    revenue: 'Przychód',
    open_inbox: 'Otwórz skrzynkę',
    referral_inbox: 'SKRZYNKA SKIEROWAŃ',
    inbound_gp_referrals: 'Skierowania przychodzące',
    inbound_lede: 'Każde zgłoszenie z publicznego linku do skierowania ląduje tutaj. Przenoś je przez „Potwierdzone → Zaplanowane" (lub „Odrzucone") — każda zmiana wysyła automatyczną odpowiedź do lekarza.',
    filter: 'Filtr',
    all_statuses: 'Wszystkie statusy',
    status_new: 'Nowe',
    status_acknowledged: 'Potwierdzone',
    status_scheduled: 'Zaplanowane',
    status_declined: 'Odrzucone',
    clear_gp_filter: 'Wyczyść filtr lekarza',
    showing_x_of_y: 'Pokazano {x} / {y}',
    no_referrals_match: 'Brak skierowań pasujących do filtra.',
    acknowledge: 'Potwierdź',
    schedule: 'Zaplanuj',
    decline: 'Odrzuć',
    audit: 'Audyt',
    referred_by: 'Skierował',
    urgency: 'Pilność',
    discipline: 'Dyscyplina',
    patient: 'Pacjent',
    refer_patient_to: 'Skieruj swojego pacjenta do',
    referrer: 'Lekarz',
    referral_received: 'Skierowanie otrzymane — dziękujemy',
    referral_received_body: 'Skontaktujemy się z {name} w ciągu jednego dnia roboczego, aby umówić pierwszą wizytę. Zespół administracyjny kliniki został powiadomiony.',
    patient_full_name: 'Imię i nazwisko pacjenta',
    patient_email: 'Email pacjenta',
    patient_phone: 'Telefon pacjenta',
    presenting_complaint: 'Dolegliwość główna',
    urgency_urgent: 'Pilne (ten tydzień)',
    urgency_standard: 'Standardowe (1–2 tygodnie)',
    urgency_flexible: 'Elastyczne',
    note_optional: 'Notatka (opcjonalna)',
    send_referral: 'Wyślij skierowanie',
    referral_link_invalid: 'Ten link skierowania jest już nieaktywny.',
    gp_prefs_title: 'Preferencje powiadomień',
    gp_prefs_lede: 'Wybierz, jakie wiadomości chcesz otrzymywać z tej kliniki.',
    pref_outcomes_report: '30-dniowy raport wyników',
    pref_outcomes_help: 'Markowy PDF wysyłany raz na każdego skierowanego pacjenta.',
    pref_status_replies: 'Aktualizacje statusu',
    pref_status_help: 'Automatyczne odpowiedzi: potwierdzono / zaplanowano / odrzucono.',
    pref_thank_you: 'Podziękowania',
    pref_thank_you_help: 'Kwartalna notatka, gdy Twoi pacjenci wyzdrowieją.',
    save_preferences: 'Zapisz preferencje',
    preferences_saved: 'Preferencje zapisane — dziękujemy.',
    export_to_pdf: 'Eksport PDF',
    no_snapshots_to_export: 'Wybierz co najmniej jedno zdjęcie do eksportu.',
    posture_pdf_caption: 'Zdjęcia postawy',
    /* Iter 90-93 — Konto i prywatność (PL) ──────────────────────────── */
    account_privacy: 'Konto i prywatność',
    account_privacy_lede: 'Uwierzytelnianie dwuskładnikowe, Twoje dane i usuwanie konta — wszystko w jednym miejscu.',
    your_data: 'Twoje dane',
    your_data_lede: 'Pobierz plik JSON zawierający wszystkie dane, jakie o Tobie przechowujemy (RODO Art. 20).',
    download_my_data: 'Pobierz moje dane (.json)',
    email_me_the_export: 'Wyślij e-mailem zamiast pobierać',
    monthly_transparency_email: 'Miesięczny e-mail transparentności',
    monthly_transparency_lede: 'Raz w miesiącu wysyłamy podsumowanie tego, co o Tobie przechowujemy (RODO Art. 12). Ostatnio wysłano: {last}.',
    email_me_monthly_summary: 'Wysyłaj mi miesięczne podsumowanie moich danych',
    privacy_preferences: 'Preferencje prywatności',
    privacy_preferences_lede: 'Włącz lub wyłącz poszczególne zastosowania danych. Wycofaj zgodę w dowolnej chwili (RODO Art. 7).',
    consent_granted: 'Wyrażono',
    consent_not_granted: 'Nie wyrażono',
    danger_zone: 'Strefa niebezpieczna',
    delete_account_lede: 'Usuń konto permanentnie. Masz 30 dni karencji — zaloguj się ponownie, aby zachować konto.',
    delete_my_account: 'Usuń moje konto',
    deletion_pending_lede: 'Twoje konto zostanie usunięte za {days} dni ({date}). Wszystkie dane zostaną nieodwracalnie usunięte po tej dacie.',
    cancel_deletion: 'Anuluj usuwanie — zachowaj moje konto',
  },
  es: {
    app: 'Physiogenic',
    tagline: 'Una plataforma moderna de fisioterapia para Physiogenic — compatible con HIPAA y RGPD.',
    cta_get_started: 'Empezar',
    cta_learn_more: 'Saber más',
    nav_features: 'Funciones',
    nav_compliance: 'Cumplimiento',
    nav_about: 'Nosotros',
    nav_about_us: 'Sobre nosotros',
    nav_platform: 'Plataforma Sanitaria Integral',
    nav_login: 'Iniciar sesión',
    nav_register: 'Crear cuenta',
    nav_logout: 'Cerrar sesión',
    auth_email: 'Correo electrónico',
    auth_password: 'Contraseña',
    auth_name: 'Nombre completo',
    auth_invite: 'Código de invitación (opcional)',
    auth_login: 'Iniciar sesión',
    auth_register: 'Crear cuenta',
    auth_or: 'o',
    auth_google: 'Continuar con Google',
    auth_google_signup: 'Registrarse con Google',
    auth_have_account: '¿Ya tienes cuenta?',
    auth_no_account: '¿No tienes cuenta?',
    dashboard: 'Panel',
    patients: 'Pacientes',
    appointments: 'Citas',
    documents: 'Documentos médicos',
    invoices: 'Facturas',
    finances: 'Finanzas',
    exercises: 'Biblioteca de ejercicios',
    marketing: 'Marketing',
    invite: 'Invitar paciente',
    taxes: 'Informes fiscales',
    profile: 'Perfil',
    upcoming: 'Próximas sesiones',
    no_data: 'Sin registros',
    new: 'Nuevo',
    edit: 'Editar',
    delete: 'Eliminar',
    cancel: 'Cancelar',
    save: 'Guardar',
    download: 'Descargar',
    upload: 'Subir',
    pay_now: 'Pagar',
    paid: 'Pagada',
    unpaid: 'Sin pagar',
    overdue: 'Vencida',
    completed: 'Completada',
    cancelled: 'Cancelada',
    scheduled: 'Programada',
    consent_gdpr: 'Acepto el tratamiento de datos (RGPD)',
    consent_hipaa: 'Acepto el manejo de registros médicos (HIPAA)',
    welcome_back: 'Bienvenido de nuevo',
    quick_actions: 'Acciones rápidas',
    /* iter 83 — patient + GP-facing tiles (ES) */
    your_recovery: 'TU RECUPERACIÓN',
    pain_label: 'Dolor NPRS / VAS',
    share: 'Compartir',
    start: 'Inicio',
    now: 'Ahora',
    better: 'mejor',
    recovered: 'Recuperado/a',
    in_progress: 'En curso',
    checkins: 'mediciones',
    recovery_help: '"Recuperado/a" significa una caída ≥ {n} puntos en tu escala de dolor — el mismo umbral que ve tu médico de referencia.',
    recovery_empty: 'Necesitamos al menos dos mediciones de dolor para mostrar tu evolución. Registra tu dolor actual tras la próxima sesión y aparecerá tu panel.',
    gp_referral_flywheel: 'EFECTO VOLANTE DE DERIVACIONES',
    gp_earnings_title: 'Ingresos e impacto del médico',
    gp_earnings_lede: 'Cada médico al que se le ha enviado un informe de resultados de 30 días aparece abajo. Ordena por sesiones realizadas, tasa de recuperación o facturación.',
    export_csv: 'Exportar CSV',
    fee_schedule: 'Tarifa de derivación',
    active_gps: 'Médicos activos',
    referrals_30d: 'Derivaciones (30 d)',
    sessions_delivered: 'Sesiones realizadas',
    clinic_revenue: 'Facturación clínica',
    top_referrer: 'Top derivador del periodo',
    gp_leaderboard: 'Ranking de médicos',
    fee_owed: 'Tarifa pendiente',
    no_gp_yet: 'Aún no hay médicos derivadores — cuando envíes un informe de 30 días (o registres un médico en la ficha de un paciente), aparecerán aquí.',
    referrals: 'Derivaciones',
    sessions: 'Sesiones',
    recovery_pct: 'Recuperación %',
    reports_sent: 'Informes enviados',
    revenue: 'Facturación',
    open_inbox: 'Abrir bandeja',
    referral_inbox: 'BANDEJA DE DERIVACIONES',
    inbound_gp_referrals: 'Derivaciones entrantes',
    inbound_lede: 'Cada envío desde un enlace público de derivación llega aquí. Mueve cada uno por Confirmada → Programada (o Rechazada) — cada cambio envía una respuesta automática al médico.',
    filter: 'Filtro',
    all_statuses: 'Todos los estados',
    status_new: 'Nueva',
    status_acknowledged: 'Confirmada',
    status_scheduled: 'Programada',
    status_declined: 'Rechazada',
    clear_gp_filter: 'Quitar filtro de médico',
    showing_x_of_y: 'Mostrando {x} / {y}',
    no_referrals_match: 'Ninguna derivación coincide con este filtro.',
    acknowledge: 'Confirmar',
    schedule: 'Programar',
    decline: 'Rechazar',
    audit: 'Auditoría',
    referred_by: 'Derivado por',
    urgency: 'Urgencia',
    discipline: 'Disciplina',
    patient: 'Paciente',
    refer_patient_to: 'Deriva tu paciente a',
    referrer: 'Médico',
    referral_received: 'Derivación recibida — gracias',
    referral_received_body: 'Contactaremos con {name} en un día laborable para programar la primera cita. El equipo administrativo de la clínica ha sido notificado.',
    patient_full_name: 'Nombre completo del paciente',
    patient_email: 'Email del paciente',
    patient_phone: 'Teléfono del paciente',
    presenting_complaint: 'Motivo de consulta',
    urgency_urgent: 'Urgente (esta semana)',
    urgency_standard: 'Estándar (1–2 semanas)',
    urgency_flexible: 'Flexible',
    note_optional: 'Nota (opcional)',
    send_referral: 'Enviar derivación',
    referral_link_invalid: 'Este enlace de derivación ya no es válido.',
    gp_prefs_title: 'Preferencias de notificación',
    gp_prefs_lede: 'Elige qué mensajes deseas recibir de esta clínica.',
    pref_outcomes_report: 'Informe de resultados a 30 días',
    pref_outcomes_help: 'Un PDF con la marca de la clínica, enviado una vez por paciente derivado.',
    pref_status_replies: 'Actualizaciones de estado',
    pref_status_help: 'Respuestas automáticas: confirmada / programada / rechazada.',
    pref_thank_you: 'Agradecimiento',
    pref_thank_you_help: 'Nota trimestral cuando tus pacientes derivados se recuperan.',
    save_preferences: 'Guardar preferencias',
    preferences_saved: 'Preferencias guardadas — gracias.',
    export_to_pdf: 'Exportar PDF',
    no_snapshots_to_export: 'Selecciona al menos una foto para exportar.',
    posture_pdf_caption: 'Fotos de postura',
    /* Iter 90-93 — Cuenta y privacidad (ES) ─────────────────────────── */
    account_privacy: 'Cuenta y privacidad',
    account_privacy_lede: 'Autenticación de dos factores, tus datos y eliminación de cuenta — todo en un solo lugar.',
    your_data: 'Tus datos',
    your_data_lede: 'Descarga un archivo JSON con todos los datos que tenemos sobre ti (RGPD Art. 20).',
    download_my_data: 'Descargar mis datos (.json)',
    email_me_the_export: 'Envíamelo por correo',
    monthly_transparency_email: 'Correo de transparencia mensual',
    monthly_transparency_lede: 'Una vez al mes te enviamos un resumen de lo que tenemos sobre ti (RGPD Art. 12). Último envío: {last}.',
    email_me_monthly_summary: 'Envíame un resumen mensual de mis datos',
    privacy_preferences: 'Preferencias de privacidad',
    privacy_preferences_lede: 'Activa o desactiva usos individuales de datos. Retira cualquier consentimiento en cualquier momento (RGPD Art. 7).',
    consent_granted: 'Otorgado',
    consent_not_granted: 'No otorgado',
    danger_zone: 'Zona de peligro',
    delete_account_lede: 'Elimina tu cuenta de forma permanente. Tienes 30 días de gracia — inicia sesión de nuevo para conservarla.',
    delete_my_account: 'Eliminar mi cuenta',
    deletion_pending_lede: 'Tu cuenta se eliminará en {days} día(s) ({date}). Todos tus datos serán borrados permanentemente tras esa fecha.',
    cancel_deletion: 'Cancelar eliminación — conservar mi cuenta',
  },
};

export function t(locale, key, vars) {
  const l = dict[locale] || dict.en;
  const raw = l[key] || dict.en[key] || key;
  // Iter 83 — simple {placeholder} interpolation. Backwards-compatible:
  // when called without `vars` (the iter1-82 signature), behaves identically.
  if (!vars) return raw;
  return raw.replace(/\{(\w+)\}/g, (_m, k) => (vars[k] != null ? String(vars[k]) : `{${k}}`));
}

export const LOCALES = [
  { code: 'en', label: 'EN' },
  { code: 'pl', label: 'PL' },
  { code: 'es', label: 'ES' },
];
